import { createContext } from 'react';
import { ID } from 'shared/types/id';
import { InsightsTimeframes } from 'shared/types/insights';
import { CreateTask, Task } from 'shared/types/task';
import { MetaViewOptions } from 'shared/views/task-detail';

export type TaskDetailActionsContextProps = {
  openTaskDetail: (task: Task | undefined, view?: MetaViewOptions) => void;
  openTaskStatistics: (
    task: Task | undefined,
    timeframe?: InsightsTimeframes,
  ) => void;
  openCreateTask: (initialValues?: Partial<CreateTask>) => void;
  closeDetail: () => void;
};

export type TaskDetailContextProps = {
  activeTaskId: ID | undefined;
  isSubmenuOpen: boolean;
  setSubmenuOpen: (isOpen: boolean) => void;
};

export const TaskDetailActionsContext =
  createContext<TaskDetailActionsContextProps>({
    openTaskDetail: () => {},
    openTaskStatistics: () => {},
    openCreateTask: () => {},
    closeDetail: () => {},
  });

export const TaskDetailContext = createContext<TaskDetailContextProps>({
  activeTaskId: undefined,
  isSubmenuOpen: false,
  setSubmenuOpen: () => {},
});
